var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-header-release",attrs:{"data-tips":_vm.$t('headerTools.mktHeader.90khcs')}},[_c('div',{staticClass:"release-button"},[_c('Icon',{staticClass:"release",attrs:{"type":"release","size":"22"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }